import type { ActorRefFrom } from 'xstate';
import type resizeMachine from '~/utils/machines/resizemachine';
import * as styles from './Sidebar.css';

export const Resizer = ({
  positionX,
  width,
  send,
  defaultWidth,
  sliderWidth,
}: {
  positionX: number;
  width: number;
  send: ActorRefFrom<typeof resizeMachine>['send'];
  defaultWidth: number;
  sliderWidth: number;
}) => {
  const left = defaultWidth - sliderWidth / 2 + (width ? width - sliderWidth / 2 : 0);
  const handleLeft = defaultWidth === positionX ? defaultWidth - sliderWidth / 2 : positionX - sliderWidth;
  const maxLeft = -sliderWidth / 2;

  return (
    <>
      <div
        style={{ left: handleLeft < 0 ? maxLeft : handleLeft }}
        className={styles.handle}
        onPointerDown={send}
        onPointerMove={send}
        onPointerUp={send}
        onPointerCancel={send}
        onPointerOut={send}
        onDoubleClick={send}
      />
      <div style={{ left: left < 0 ? maxLeft : left }} className={styles.slider} />
    </>
  );
};
